import { useQuery } from "@tanstack/react-query";
import { saleEventsRepository } from "@/services";
import { useTenant } from "./useTenant";

export type SaleEventType =
  | "checkout_link_sent"
  | "payment_confirmed"
  | "fulfillment_pending"
  | "fulfillment_ready"
  | "dispatched"
  | "delivered"
  | "concluded"
  | "checkout_reactivated"
  | "checkout_expired"
  | "cancelled";

export interface SaleEvent {
  id: string;
  sale_id: string;
  tenant_id: string;
  event_type: SaleEventType | string;
  message: string;
  created_at: string;
}

export function useSaleHistory(saleId: string | null | undefined) {
  const { tenant } = useTenant();
  const tenantId = tenant?.id;

  const { data: events = [], isLoading, error } = useQuery({
    queryKey: ["sale-history", tenantId, saleId],
    queryFn: async () => {
      if (!saleId) return [] as SaleEvent[];

      const { data, error } = await saleEventsRepository.list(saleId, tenantId!);

      if (error) throw error;
      return (data ?? []) as SaleEvent[];
    },
    enabled: !!saleId && !!tenantId,
    staleTime: 1000 * 60 * 5,
  });

  return { events, isLoading, error };
}
